import { render } from "./Logo.vue?vue&type=template&id=79ebffe7&scoped=true&ts=true"
import script from "./Logo.vue?vue&type=script&lang=ts"
export * from "./Logo.vue?vue&type=script&lang=ts"

import "./Logo.vue?vue&type=style&index=0&id=79ebffe7&lang=scss&scoped=true"

import exportComponent from "/Users/yuhuiliu/code/btkcode/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ebffe7"]])

export default __exports__